import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _defineProperty from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import axios from "axios";
export default {
  namespaced: true,
  state: {
    filters: {
      developmentName: "",
      cityIds: [],
      zipIds: [],
      countyIds: [],
      types: []
    },
    results: [],
    countiesOptions: [],
    citiesOptions: [],
    zipCodeOptions: [],
    zipCityCounty: [],
    otherResources: [],
    page: 1,
    perPage: 10,
    loading: false
  },
  getters: {
    filters: function filters(state) {
      return state.filters;
    },
    results: function results(state) {
      return state.results;
    },
    paginatedResults: function paginatedResults(state) {
      var start = (state.page - 1) * state.perPage;
      return state.results.slice(start, start + state.perPage);
    },
    maxPage: function maxPage(state) {
      return Math.ceil(state.results.length / state.perPage);
    },
    markers: function markers(state) {
      var start = (state.page - 1) * state.perPage;
      return state.results.slice(start, start + state.perPage).filter(function (r) {
        return r.pR_LATITUDE && r.pR_LONGITUDE;
      }).map(function (r, index) {
        return {
          position: {
            lat: Number(r.pR_LATITUDE),
            lng: Number(r.pR_LONGITUDE)
          },
          projectId: r.projectId,
          label: String(index + 1 + start),
          title: r.developmentName
        };
      });
    }
  },
  mutations: {
    SET_FILTERS: function SET_FILTERS(state, filters) {
      state.filters = _objectSpread({}, filters);
    },
    SET_RESULTS: function SET_RESULTS(state, results) {
      state.results = results;
      state.page = 1;
    },
    SET_PAGE: function SET_PAGE(state, page) {
      state.page = page;
    },
    SET_PER_PAGE: function SET_PER_PAGE(state, value) {
      state.perPage = value;
      state.page = 1;
    },
    SET_LOADING: function SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_COUNTIES: function SET_COUNTIES(state, counties) {
      state.countiesOptions = counties;
    },
    SET_CITIES: function SET_CITIES(state, cities) {
      state.citiesOptions = cities;
    },
    SET_ZIPCODES: function SET_ZIPCODES(state, zipCodes) {
      state.zipCodeOptions = zipCodes;
    },
    SET_ZIPCITYCOUNTY: function SET_ZIPCITYCOUNTY(state, zipCityCounty) {
      state.zipCityCounty = zipCityCounty;
    },
    SET_OTHERRESOURCES: function SET_OTHERRESOURCES(state, otherResources) {
      state.otherResources = otherResources;
    }
  },
  actions: {
    fetchProjectLocationData: function () {
      var _fetchProjectLocationData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(_ref) {
        var commit, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit = _ref.commit;
                _context.prev = 1;
                _context.next = 4;
                return axios.get('/api/affordablehousinglocator/projectLocationData');

              case 4:
                response = _context.sent;
                commit('SET_COUNTIES', response.data.counties);
                commit('SET_CITIES', response.data.cities);
                commit('SET_ZIPCODES', response.data.zipCodes);
                _context.next = 16;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](1);
                console.error('Failed to fetch project location data:', _context.t0);
                commit('SET_COUNTIES', []);
                commit('SET_CITIES', []);
                commit('SET_ZIPCODES', []);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 10]]);
      }));

      function fetchProjectLocationData(_x) {
        return _fetchProjectLocationData.apply(this, arguments);
      }

      return fetchProjectLocationData;
    }(),
    fetchZipCityCounty: function () {
      var _fetchZipCityCounty = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(_ref2) {
        var commit, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commit = _ref2.commit;
                _context2.next = 3;
                return axios.get('/api/affordablehousinglocator/zipcitycounty');

              case 3:
                response = _context2.sent;
                commit('SET_ZIPCITYCOUNTY', response.data.zipCityCountyResult);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function fetchZipCityCounty(_x2) {
        return _fetchZipCityCounty.apply(this, arguments);
      }

      return fetchZipCityCounty;
    }(),
    fetchOtherResources: function () {
      var _fetchOtherResources = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(_ref3) {
        var commit, response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                commit = _ref3.commit;
                _context3.next = 3;
                return axios.get('/api/affordablehousinglocator/otherResources');

              case 3:
                response = _context3.sent;
                commit('SET_OTHERRESOURCES', response.data.otherResourcesResult);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function fetchOtherResources(_x3) {
        return _fetchOtherResources.apply(this, arguments);
      }

      return fetchOtherResources;
    }(),
    search: function () {
      var _search = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(_ref4) {
        var commit, state, response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                commit = _ref4.commit, state = _ref4.state;
                commit('SET_LOADING', true);
                _context4.prev = 2;
                _context4.next = 5;
                return axios.get('/api/affordablehousinglocator/search', {
                  params: state.filters,
                  paramsSerializer: function paramsSerializer(params) {
                    var parts = [];
                    Object.keys(params).forEach(function (key) {
                      var value = params[key];

                      if (Array.isArray(value) && value.length > 0) {
                        value.forEach(function (v) {
                          if (v !== null && v !== undefined) {
                            parts.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(v)));
                          }
                        });
                      } else if (value !== null && value !== undefined && value !== '' && !Array.isArray(value)) {
                        parts.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value)));
                      }
                    });
                    return parts.join('&');
                  }
                });

              case 5:
                response = _context4.sent;
                commit('SET_RESULTS', response.data.results);

              case 7:
                _context4.prev = 7;
                commit('SET_LOADING', false);
                return _context4.finish(7);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[2,, 7, 10]]);
      }));

      function search(_x4) {
        return _search.apply(this, arguments);
      }

      return search;
    }()
  }
};